export const removeWmsSitesLayer = (map, layerName) => {
  if (map.current.getSource('sitesLayers')) {
    map.current.removeLayer('sitesLayers');
    map.current.removeSource('sitesLayers');
  }
  if (map.current.getSource('fiberSitesLayer')) {
    map.current.removeLayer('fiberSitesLayer');
    map.current.removeSource('fiberSitesLayer');
  }
};
